class RelatedVideosPopup extends HTMLElement {
    constructor() {
      super();
      
      this.selectors = {
        videoPlayerContainer: '.product-related-video-player-container',
        videoPlaylistMobile: '.product-related-video-playlist-mobile',
        draggableElement: '#product-related-video-player-draggable-el',
        closeButton: '.js-product-related-video-player-close-button',
        videoJS: '.video-js'
      }

      this.closeButton = this.querySelector(this.selectors.closeButton);
      this.wrapper = this;
      this.player = false;
      this.init();   
      this.isMobile = false;
    }
  
  init() {
    this.initVideoPlayer();
    this.initInteract();
    //this.initPlaylist();
    this.initEventListeners();
    
  }

  initEventListeners() {
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.closeButton.addEventListener('click', this.close.bind(this));
    window.addEventListener('resize', throttle(this.onResize.bind(this), 500));
  }

  onResize() {
    let windowWidth = window.innerWidth;

    console.log('hello', windowWidth)

    this.isMobile = windowWidth > 768 ? false : true;
  }

  initPlaylist(playlist, data) {
    if (!data) {
      data = {}
    }
    console.log('init playlist', playlist);
    this.player.playlist(playlist, 0);
    this.player.playlist.autoadvance(5);
 
    this.player.playlistUi({
      title: data.title || "Related Videos",
      title2: data.title2 || "",
      mobileTitle: data.mobileTitle || "Related Videos",
      isMobile: this.isMobile
    })
   
  }

  getVideoPlayer() {
    return this.player;
  }

  initVideoPlayer() {
    
    var windowWidth = window.innerWidth;
    this.isMobile = windowWidth > 768 ? false : true;

    let playlistContainer = document.createElement('div');
    playlistContainer.classList.add('vjs-playlist');
    if (!this.isMobile) {
      this.querySelector(this.selectors.videoPlayerContainer).appendChild(playlistContainer);
    } else {
      playlistContainer.classList.add('vjs-playlist-mobile')
      this.querySelector(this.selectors.videoPlaylistMobile).appendChild(playlistContainer);
    }

    var vidOpts = {
      controls: true,
      preload: "none",
      autoPlay: true,
      playsinline: true,
      controlBar: {
        volumePanel: { inline: true },
      },
      fill: true,
      aspectRatio: '16:9'
    };

    this.player = videojs("product-related-video-player", vidOpts, function () { });
  }

  initInteract() {

    let draggableElement = this.wrapper.querySelector(this.selectors.draggableElement);

    //init interact
    interact(draggableElement)
    .draggable({
      startAxis: 'y',
      lockAxis: 'y',
      inertia: true,
      listeners: {
        move: dragMoveListener
      },
        modifiers: [
        interact.modifiers.snap({
          targets: [ { x: 0, y: 700, range: 100 }, { x: 0, y: 1, range: 100 } ],

        })
      ]
    })

    function dragMoveListener (event) {
      var target = event.target
      // keep the dragged position in the data-x/data-y attributes
      //get default height based on 10% of element
      let targetHeight = interact.getElementRect(event.target).height * -1;
      //var yDefault = targetHeight * 0.9;
      //starting height of video tab
      var yDefault = -190;
      var x = (parseFloat(target.getAttribute('data-x')) || 0) + event.dx
      var y = (parseFloat(target.getAttribute('data-y')) || yDefault) + event.dy

      if(y < targetHeight){
        y = targetHeight;
      }else if(y > yDefault) {
        y = yDefault
      }

      // translate the element
      target.style.transform = 'translate(' + x + 'px, ' + y + 'px)'

      // update the posiion attributes
      target.setAttribute('data-x', x)
      target.setAttribute('data-y', y)
    }
  }

  close(){
    this.player.pause();
    this.wrapper.style.display = "none";
    $('body, html').css('overflow', '');
    $('body, html').removeClass('video-related-popup--open');
    
  }

  open(src) {

    if (!src) return;

    this.wrapper.style.display = "flex";
    $('body, html').css('overflow', 'hidden');
    $('body, html').addClass('video-related-popup--open');
    console.log('element:', this.querySelector(this.selectors.mainVideoElement));
    this.querySelector(this.selectors.videoJS).focus();
    this.playVideo(src);
  }

  playVideo(src) {
    if (!src) return;

    this.player.src(src);
    this.player.play();
  }

  onFocusOut() {
      setTimeout(() => {
        if (!this.querySelector(this.selectors.videoPlayerContainer).contains(document.activeElement)) this.close();
      });
  }

}

  customElements.define('related-video-popup', RelatedVideosPopup);